module.exports = __webpack_public_path__ + "media/images/png/newsletter_logo-c2e6928eab588036033a728f723a949e.png";